import {createSelector} from '@ngrx/store';

import {CURRENCIES_FEATURE_KEY, selectMasterDataModuleState} from '../reducers';

export const selectCurrenciesState = createSelector(
  selectMasterDataModuleState,
  (moduleState) => moduleState[CURRENCIES_FEATURE_KEY]
);

export const selectCurrenciesEntities = createSelector(
  selectCurrenciesState,
  (state) => state.entities
);

export const selectCurrencies = createSelector(
  selectCurrenciesEntities,
  (entities) => Object.values(entities)
);

/////////////////////////////////////////////////////////////////////////////////////////////////////////////// Errors

export const selectErrors = createSelector(
  selectCurrenciesState,
  (state) => state.errors
);

/////////////////////////////////////////////////////////////////////////////////////////////////////// Loading States

export const isLoading = createSelector(
  selectCurrenciesState,
  (state) => state.loading
);

export const isLoaded = createSelector(
  selectCurrenciesState,
  (state) => state.loaded
);
